import React from 'react';
import {FormattedMessage, useIntl} from 'react-intl';
import {
    Box,
    Button,
    Container,
    createStyles,
    FormControl,
    InputLabel,
    Link,
    MenuItem,
    Select,
    Theme,
    Typography
} from '@material-ui/core';
import {makeStyles} from "@material-ui/core/styles";
import { Locale } from './api/model';

interface Props {
  locale: Locale,
  changeLocale: (locale: Locale) => void
}

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        footerNavigationLink: {
            '&:not(:last-child)': {
                marginRight: theme.spacing(5)
            }
        },
        languageSelect: {
            width: 60
        },
        hmcLink: {
            marginLeft: theme.spacing(-1.5)
        }
    }),
);

const Footer: React.FunctionComponent<Props> = (props) => {
    const intl = useIntl();

    const classes = useStyles();

    const getCurrentYear = () => {
        return new Date().getFullYear();
    };

    return (
        <Box component='footer' bgcolor='primary.main' color='common.white' py={{xs: 4, md: 5}}>
            <div style={{display: 'none'}} />
            <Container maxWidth='lg'>
                <Box display='flex'
                     justifyContent={{md: 'space-between'}}
                     flexDirection={{xs: 'column', md: 'row'}}
                     alignItems={{md: 'flex-end'}}
                >
                    <Box display='inline-flex' pb={{xs: 1.2, md: 0.8}}>
                        <Button target='_blank'
                                href={intl.formatMessage({id: 'LinkHMC'})}
                                component='a'
                                variant='text'
                                color='inherit'
                                className={classes.hmcLink}
                        >
                            <FormattedMessage id='HMC'/>
                        </Button>
                    </Box>

                    <Box display='flex' flexDirection='column'>
                        <Box display='flex' justifyContent='flex-end' mb={3.5}>
                            <FormControl className={[classes.languageSelect, 'form--white'].join(' ')}>
                                <InputLabel id="language-label" className='form--white'>
                                    <FormattedMessage id='Language'/>
                                </InputLabel>
                                <Select
                                    className='form--white'
                                    fullWidth
                                    inputProps={{
                                        classes: {
                                            icon: 'form--white',
                                        }
                                    }}
                                    labelId="language-label"
                                    value={props.locale}
                                    onChange={(event) => props.changeLocale((event.target.value as Locale))}
                                >
                                    <MenuItem value={Locale.DE}>DE</MenuItem>
                                    <MenuItem value={Locale.EN}>EN</MenuItem>
                                </Select>
                            </FormControl>
                        </Box>
                        <Box textAlign='right'
                             component='nav'
                             mb={{xs: 3, md: 2}}
                        >
                            <Link href={intl.formatMessage({id: 'LinkPrivacyPolicy'})}
                                  target='_blank'
                                  variant='body2'
                                  color='inherit'
                                  className={classes.footerNavigationLink}
                            >
                                <FormattedMessage id='LinkTitlePrivacyPolicy' />
                            </Link>
                            <Link href={intl.formatMessage({id: 'LinkImprint'})}
                                  target='_blank'
                                  variant='body2'
                                  color='inherit'
                                  className={classes.footerNavigationLink}
                            >
                                <FormattedMessage id='LinkTitleImprint' />
                            </Link>
                        </Box>
                    </Box>
                </Box>

                <Box textAlign='right'>
                    <Typography variant='body2'>
                        &copy; {getCurrentYear()} <FormattedMessage id='HMCCompanyName' />
                    </Typography>
                </Box>

            </Container>
        </Box>
    )
};

export default Footer;
